
export const StyledDatesChips = {
  errorChip: {
    backgroundColor: "#FF9A78",
    color: "white",
  },
  warningChip: {
    backgroundColor: "orange",
    color: "white"
  },
  successChip: {
    backgroundColor: "#8BC34A",
    color: "white",
  },
};